<template>
  <LoadingView :loading="isLoading">
    <div v-for="(field, i) in fields">
      <Field
        v-if="i === currentStep"
        class="not-prose"
        :key="field.id"
        :uuid="field.id"
        v-model="model[field.id]"
        :content="field.content"
        :errors="error ? ['Обязательное поле'] : []"
      >
        <template #label="{ content, asteriskClasses }">
          <div class="flex items-start w-full mb-4 justify-between">
            <span
              v-text="content.title"
              :class="
                [...(content.required ? asteriskClasses : [])].filter(Boolean)
              "
              class="dark:text-white text-black max-w-[75%] ml-2"
            />

            <div
              v-if="fields?.length > 1"
              class="flex items-center justify-center gap-1 mt-2.5"
            >
              <div v-for="i in fields.length">
                <span
                  class="block w-2 h-2 bg-white/30 rounded-full transition-colors"
                  :class="{ '!bg-primary': i === currentStep + 1 }"
                />
              </div>
            </div>
          </div>
        </template>
      </Field>
    </div>

    <div class="flex items-center gap-4">
      <UIButton
        v-if="currentStep > 0 && !isProcessingCallback"
        class="mt-6 w-full"
        size="lg"
        title="Назад"
        type="gray"
        @click="backward"
      />
      <UIButton
        class="mt-6 w-full"
        size="lg"
        :is-loading="isProcessingCallback"
        :loading-icon="LoadingIcon"
        :title="currentStep + 1 === fields?.length ? 'Отправить' : 'Далее'"
        @click="forward"
      />
    </div>
  </LoadingView>
</template>

<script setup>
import { isEmpty, isNumber } from 'lodash-es'
import { computed, inject, onMounted, ref } from 'vue'

import LoadingIcon from '@/components/loading/LoadingIcon.vue'
import LoadingView from '@/components/loading/LoadingView.vue'
import Field from '@/components/player/components/Field.vue'
import UIButton from '@/components/ui/UIButton.vue'

const props = defineProps({
  form: {
    type: String,
    required: true,
  },
  callback: {
    type: Function,
  },
})

const model = ref({})
const error = ref(false)

const http = inject('http')
const formData = ref()
const isLoading = ref(true)
const currentStep = ref(0)
const isProcessingCallback = ref(false)

onMounted(() => {
  http(`/form-builder/forms/${props.form}`)
    .then(({ resource }) => {
      formData.value = resource
    })
    .finally(
      setTimeout(() => {
        isLoading.value = false
      }, 300),
    )
})

const fields = computed(() => {
  return formData.value?.sections
    .reduce((acc, i) => {
      acc = [...acc, ...i.blocks]

      return acc
    }, [])
    .filter((i) => i.type === 'field')
})

function forward() {
  const stepValue = model.value[fields.value[currentStep.value].id]
  if (!isEmpty(stepValue) || isNumber(stepValue)) {
    if (currentStep.value + 1 < fields.value.length) {
      currentStep.value = currentStep.value + 1
    } else {
      isProcessingCallback.value = true
      props.callback(model.value).finally(() => {
        isProcessingCallback.value = false
      })
    }
    error.value = false
  } else {
    error.value = true
  }
}

function backward() {
  if (currentStep.value - 1 >= 0) {
    currentStep.value = currentStep.value - 1
  }
}
</script>
